module.exports = __webpack_public_path__ + "img/image_ot-flags_1920px.dd5865ad.jpg";